import { focusAreas } from '@/mocks/homeData';

export default function FocusAreas() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl mb-10 md:mb-14">
          <span className="text-xs font-medium tracking-widest text-primary-600 uppercase">
            我们能做什么
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3 mb-4">
            四种方式，把零散爆料整理成可对照的线索
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            单条消息容易看过就忘，真正有参考价值的是事件之间的关系。我们把内容拆成四条相互衔接的能力，
            让每一个案例都能被放回同一条线索里理解。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {focusAreas.map((item, index) => {
            const accentClass =
              index % 3 === 0
                ? 'bg-primary-100 text-primary-700'
                : index % 3 === 1
                  ? 'bg-accent-100 text-accent-700'
                  : 'bg-secondary-100 text-secondary-700';
            return (
              <article
                key={item.title}
                className="group bg-background-100 border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-colors"
              >
                <div className="flex items-start justify-between mb-5">
                  <span className={`w-12 h-12 flex items-center justify-center rounded-lg ${accentClass}`}>
                    <i className={`${item.icon} text-2xl`}></i>
                  </span>
                  <span className="text-[11px] font-medium text-foreground-500 border border-background-300 rounded-full px-2.5 py-1 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}